<!-- https://www.figma.com/design/04SlAQDbb2M2yNzPgjjpvF/Genoplan-X-(Mobile)-1.1?node-id=9338-27430&t=3ajDeqiM5T6HSVu1-4 -->
<template>
  <Toast position="bottom-center">
    <template #message="slotProps">
      <div class="flex items-center">
        <i
          v-if="slotProps.message.severity == 'success'"
          class="mr-2 pi pi-check text-verdigris-500 text-18"
        />
        <i
          v-else-if="slotProps.message.severity == 'error'"
          class="mr-2 text-red-500 pi pi-times text-14"
        />
        <i
          v-else-if="slotProps.message.severity == 'link'"
          class="mr-2 text-blue-500 pi pi-link text-20"
        />

        <span
          class="font-bold text-grey-700"
          v-html="slotProps.message.detail"
        />
      </div>
    </template>
  </Toast>
</template>
